/**
 * aswbe checkin eapi
 * チェックイン業務で利用するAPIを提供する
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PostSeatmapResponseDataSeatmapsDecksInnerSeats } from './postSeatmapResponseDataSeatmapsDecksInnerSeats';
import { PostSeatmapResponseDataSeatmapsDecksInnerColumnsInner } from './postSeatmapResponseDataSeatmapsDecksInnerColumnsInner';

export interface PostSeatmapResponseDataSeatmapsDecksInner {
  /**
   * デッキの位置情報<br> main:1F<br> upper:2F
   */
  deckType?: PostSeatmapResponseDataSeatmapsDecksInner.DeckTypeEnum;
  /**
   * 列情報のリスト。座席列と通路列が含まれる。
   */
  columns?: Array<PostSeatmapResponseDataSeatmapsDecksInnerColumnsInner>;
  /**
   * 通路数。列情報リストの通路数から算出する。
   */
  numberOfAisle?: number;
  seats?: PostSeatmapResponseDataSeatmapsDecksInnerSeats;
}
export namespace PostSeatmapResponseDataSeatmapsDecksInner {
  export type DeckTypeEnum = 'main' | 'upper';
  export const DeckTypeEnum = {
    Main: 'main' as DeckTypeEnum,
    Upper: 'upper' as DeckTypeEnum,
  };
}
